import { KeyPrefix, Namespace } from 'i18next';
import React, { ReactElement } from 'react';
import { FallbackNs, ReportNamespaces, Trans, useTranslation, UseTranslationOptions } from 'react-i18next';

interface i18n {
    reportNamespaces: ReportNamespaces;
}

type TransCreatorFunction = (key: string,
  defaultValue?: string,
  values?: {},
  components?: React.ReactElement[]) => ReactElement;

export function useTrans(ns?: Namespace,
                         options?: UseTranslationOptions<KeyPrefix<FallbackNs<'translation'>>>): {
                          trans: TransCreatorFunction, i18n:i18n, ready: boolean
                        } {
  const trans:TransCreatorFunction = (key: string,
    defaultValue: string = key,
    values?: {},
    components?: React.ReactElement[]) => <Trans
                                          i18n={i18n}
                                          t={t}
                                          i18nKey={key}
                                          values={values}
                                          components={components}>{ defaultValue }
                                        </Trans>;
  const [t, i18n, ready] = useTranslation(ns, options);

  return {trans, i18n, ready};
}

export enum LANGUAGES {
  PL = 'pl',
  EN = 'en'
}
export const DEFAULT_LANGUAGE = LANGUAGES.PL;
export const AVAILABLE_LANGUAGES = [LANGUAGES.PL, LANGUAGES.EN]